var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddAttachment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.52 19.038a3.436 3.436 0 01-2.462-1.007A3.315 3.315 0 010 15.5a4.352 4.352 0 011.441-2.834L11.675 2.432a4.877 4.877 0 116.9 6.895L9.65 18.251a.495.495 0 11-.7-.7l8.924-8.924a3.892 3.892 0 00-5.5-5.5L2.14 13.358a3.467 3.467 0 00-1.154 2.186 2.36 2.36 0 00.768 1.791 2.477 2.477 0 001.938.714 3.434 3.434 0 002.188-1.05l8.225-8.229a1.295 1.295 0 10-1.83-1.831l-6.844 6.843a.495.495 0 01-.7-.7l6.844-6.843a2.279 2.279 0 113.222 3.223l-8.225 8.23a4.416 4.416 0 01-2.824 1.336c-.074.008-.148.01-.228.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAttachment);
export default __webpack_public_path__ + "static/media/add_attachment.250c71bc34b769c33cb11961343ff59e.svg";
export { ForwardRef as ReactComponent };